import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import usePrevious from '../../../common/hooks/usePrevious';
import ConnectedNotificationList from './NotificationList';
import ConnectedNotification from './Notification';
import AddNotification from './AddNotification';
import ErrorBoundary from '../../../common/ErrorBoundary';
import ContentCard from '../../../common/ContentCard';
import {
    challengeNotificationsRequested,
    addChallengeNotificationRequested,
    notificationsReset,
} from '../actions';
import {
    getChallengeNotifications,
    getChallengeNotificationsLoading,
    getAddNotificationLoading,
    getNotificationMoreData,
} from '../selectors';
import { getUser } from '../../auth/selectors';
import './styles.scss';

function Notifications({
    notifications,
    loadingNotifications,
    addingNotification,
    fetchNotifications,
    createNotification,
    resetNotifications,
    canSendNotification,
    hasMoreData,
    challenge,
    user,
}) {
    const [addingNew, setAddingNew] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(
        notifications.length ? notifications[0] : {},
    );
    const prevNotifications = usePrevious(notifications);
    const challengeCreatedByUser =
        challenge &&
        user &&
        user.partnerId &&
        challenge.partnerId == user.partnerId;

    useEffect(() => {
        resetNotifications();
        fetchNotifications();
    }, []);

    useEffect(() => {
        if (
            prevNotifications &&
            !prevNotifications.length &&
            notifications.length
        ) {
            setSelectedNotification(notifications[0]);
        }

        if (notifications.length === 0) {
            setSelectedNotification({});
        }
    }, [notifications]);

    const header = (
        <>
            <h2 className="title">Notifications</h2>
            {challengeCreatedByUser &&
            canSendNotification &&
            challenge.isPublished ? (
                !addingNew ? (
                    <button onClick={() => setAddingNew(true)}>
                        + Create New
                    </button>
                ) : null
            ) : null}
        </>
    );

    const mainContent = (
        <div className="content-box p-0">
            <div className="row">
                <div className="col-6">
                    <ErrorBoundary>
                        <ConnectedNotificationList
                            onClick={(note) => setSelectedNotification(note)}
                            notifications={notifications}
                            selectedNotification={selectedNotification}
                            loading={loadingNotifications}
                            moreDataCallback={() => {
                                fetchNotifications();
                            }}
                            hasMoreData={hasMoreData}
                        />
                    </ErrorBoundary>
                </div>
                <div className="col-6 right-container">
                    <ErrorBoundary>
                        {addingNew ? (
                            <AddNotification
                                loading={addingNotification}
                                onSave={({ headline, body }) =>
                                    createNotification({
                                        title: headline,
                                        message: body,
                                    })
                                }
                                onCancel={() => setAddingNew(false)}
                            />
                        ) : (
                            <ConnectedNotification
                                title={selectedNotification.title}
                                desc={selectedNotification.message}
                            />
                        )}
                    </ErrorBoundary>
                </div>
            </div>
        </div>
    );

    return (
        <ContentCard
            heading={header}
            subHeading={''}
            showDropDown={false}
            content={mainContent}
            cardSize={7}
            className="challenge-notifications"
        />
    );
}

Notifications.propTypes = {
    notifications: PropTypes.array,
    loadingNotifications: PropTypes.bool,
    addingNotification: PropTypes.bool,
    fetchNotifications: PropTypes.func,
    createNotification: PropTypes.func,
    resetNotifications: PropTypes.func,
    hasMoreData: PropTypes.bool,
    user: PropTypes.object,
    challenge: PropTypes.object,
    canSendNotification: PropTypes.bool,
};

Notifications.defaultProps = {
    notifications: [],
};

const mapStateToProps = (state) => {
    return {
        notifications: getChallengeNotifications(state),
        loadingNotifications: getChallengeNotificationsLoading(state),
        addingNotification: getAddNotificationLoading(state),
        hasMoreData: getNotificationMoreData(state),
        user: getUser(state),
        // requestedLimit: getRequestedSegmentsLimit(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchNotifications: () => dispatch(challengeNotificationsRequested()),
        createNotification: (notification) =>
            dispatch(addChallengeNotificationRequested(notification)),
        resetNotifications: () => dispatch(notificationsReset()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
